import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { BrandService } from 'brand';
import { ContestService } from 'contest-data-access';
import { emailValidator } from 'form-field';
import { SvgComponent } from 'icon';
import { ButtonComponent } from 'sakura-ui';
import { ToastService } from 'toast';
import { TranslatePipe, TranslateService } from 'translate';

@Component({
  selector: 'lib-newsletter',
  templateUrl: './newsletter.component.html',
  imports: [TranslatePipe, NgClass, ReactiveFormsModule, ButtonComponent, SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterComponent {
  private contestService = inject(ContestService);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);
  private destroyRef = inject(DestroyRef);
  public brand = inject(BrandService);
  public newsletterForm = new FormGroup({
    email: new FormControl<string>(null, emailValidator),
  });
  public formSubmitAttempt = signal(false);
  public loading = signal(false);

  public submit() {
    this.formSubmitAttempt.set(true);

    if (this.newsletterForm.invalid || this.loading()) {
      return;
    }

    this.loading.set(true);

    this.contestService
      .submitContestData({
        emailAddress: this.newsletterForm.value.email,
        contestName: 'subscribe_online',
        trackingCookie: '',
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading.set(false);
          this.formSubmitAttempt.set(false);
        })
      )
      .subscribe(() => {
        this.newsletterForm.reset();
        this.toastService.add(this.translateService.getTranslation(['confirmationSubsNewsletterNotification']));
      });
  }
}
